import type { PaneConversation } from "./conversation-rendered.js";

// The conversation the Alerts context pane is rendering right now (null = no pane, or a
// non-conversation target such as a task / permission card). Published by ActivityPane,
// read by app.svelte.ts through conversationRendered().
class AlertsPaneState {
  conversation = $state<PaneConversation | null>(null);
}
export const alertsPaneState = new AlertsPaneState();
